export default {
  common: {
    days: 'Days',
    today: 'Today',
    remaining: 'Left',
    elapsed: 'Passed',
    passed: 'Passed',
    justToday: 'It\'s Today! 🎉',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    share: 'Share',
    loading: 'Loading magic...',
    processing: 'Processing...',
    demoBadge: 'Demo',
    saveFailed: 'Save Failed 🥺',
    deleteFailed: 'Delete Failed 🥺',
    gotIt: 'Got it',
  },
  date: {
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  },
  theme: {
    sakura: 'Sakura Pink',
    mint: 'Mint Green',
    lavender: 'Lavender Purple',
    butter: 'Butter Yellow',
    sky: 'Starry Blue',
    elapsed: 'Memory Gray'
  },
  category: {
    all: 'All Categories',
    life: 'Life',
    work: 'Work',
    birthday: 'Birthday',
    travel: 'Travel',
    love: 'Love',
    other: 'Other'
  },
  sort: {
    default: 'Default (Closest Date)',
    targetDesc: 'Furthest Date',
    createdDesc: 'Newly Created',
    titleAsc: 'Title A-Z'
  },
  nav: {
    brandSubtitle: '倒數日',
    sponsor: 'Support Us',
    toggleTheme: 'Toggle Theme',
    toggleLang: 'Change Language',
    addEvent: 'Add Event',
    login: 'Login',
    logout: 'Logout',
    profile: 'Logged in as',
    guestHint: '👋 Guest mode. ',
    guestLink: 'Login here',
    guestSave: ' to save your cute memories!',
    features: 'Features',
    help: 'FAQ',
    home: 'Home'
  },
  home: {
    tabs: {
      all: 'All Events',
      future: 'Future',
      past: 'Past'
    },
    empty: {
      title: 'No events yet',
      desc: 'Let\'s add your first exciting event!',
      button: '+ Create Event',
      noData: 'It\'s empty here 🍃'
    },
    sections: {
      future: 'Looking Forward',
      past: 'Treasured Memories'
    },
    hero: {
      pinned: '✨ Pinned',
      coming: '🎈 Coming Soon',
      recent: '🕰️ Recent Memory',
      target: 'Target Date: '
    }
  },
  modal: {
    addTitle: 'New Event 🎈',
    editTitle: 'Edit Memory ✏️',
    titleLabel: 'Title',
    titlePlaceholder: 'Event name (Max 30 chars)...',
    pinned: 'Pinned',
    setPinned: 'Pin it',
    themeLabel: 'Card Theme',
    iconLabel: 'Choose Icon',
    categoryLabel: 'Category',
    dateLabel: 'Target Date',
    noteLabel: 'Note (Optional)',
    notePlaceholder: 'Write something (Max 100 chars)...',
    deleteBtn: 'Delete',
    saveBtn: 'Save Magic ✨',
    editBtn: 'Edit Event'
  },
  confirm: {
    title: 'Delete this memory?',
    message: 'Once deleted, it cannot be recovered! Are you sure? 🥺',
    cancel: 'Cancel',
    confirm: 'Delete',
    logoutTitle: 'Ready to leave?',
    logoutMessage: 'Are you sure you want to log out of your account?',
    logoutConfirm: 'Logout',
    logoutCancel: 'Stay'
  },
  share: {
    title: 'Share Beautiful Card',
    igPost: 'Instagram Post (1:1)',
    igStory: 'Story (9:16)',
    downloading: 'Casting magic...',
    download: 'Save Image',
    error: 'Failed to generate image, please try again 🥺'
  },
  seduction: {
    title: '✨ Awesome! Memory Created!',
    message1: 'Your beautiful countdown card is ready!',
    message2: 'However, you are in "Guest Mode", so it\'s only saved on this device 🥺',
    message3: 'To prevent losing it when clearing cache or switching phones, take 10 seconds to register and securely back it up to the cloud! ☁️',
    registerBtn: 'Login / Register 🚀',
    cancelBtn: 'Maybe Later'
  },
  sponsor: {
    title: 'Support DaysMatter 💖',
    desc1: 'If ',
    desc2: ' adds a little joy to your life, ',
    desc3: 'consider buying us a coffee to keep the magic alive and bring more cute features! ✨',
    monthly: 'Monthly',
    onetime: 'One-time',
    btn: 'Support',
    secure: 'Secure payment processed by Stripe. Currency: USD.',
    coffee: 'Love DaysMatter? Buy us a coffee!',
    tiers: {
      m5: { name: 'Buy us a coffee ☕', desc: 'A monthly coffee to keep us energized!' },
      m8: { name: 'Buy us a cake 🍰', desc: 'A monthly cake to make development sweet!' },
      m10: { name: 'Luxury tea time 🫖', desc: 'Monthly luxury tea to unlock max motivation!' },
      o5: { name: 'Cheer up 🎈', desc: 'A little encouragement goes a long way!' },
      o8: { name: 'Warm support 💖', desc: 'Your support drives us forward!' },
      o10: { name: 'Super sponsor 🌟', desc: 'Big hugs! Thanks for your powerful support!' }
    }
  },
  footer: {
    follow: 'Follow Us',
    madeWith: 'Made with',
    by: 'by'
  },
  login: {
    welcome: 'Welcome to DaysMatter',
    subtitle: 'Record every shining moment ✨',
    email: 'Email address ✉️',
    password: 'Password 🔒',
    passwordHint: '💡 Password must be at least 8 characters',
    loginBtn: 'Login Now 🚀',
    registerBtn: 'Sign Up 🎉',
    toggleToRegister: 'No account? Create one!',
    toggleToLogin: 'Already have an account? Login',
    or: 'OR',
    guestBtn: 'Explore as Guest 🚶',
    error: 'Email and password are required',
    forgotPassword: 'Forgot Password?',
    resetTitle: 'Reset Password',
    resetDesc: 'Enter your email to receive a reset link.',
    sendResetBtn: 'Send Reset Link',
    backToLogin: 'Back to Login',
    resetSuccess: 'Reset link sent! Please check your email inbox (and spam folder).',
    newPassword: 'New Password 🔒',
    updatePasswordBtn: 'Update Password',
    updateSuccess: 'Password updated successfully! Please login again.',
    invalidToken: 'Invalid Reset Token',
    invalidTokenDesc: 'No reset token found in URL. Please request a new password reset link.',
    backBtn: 'Back'
  },
  errors: {
    missingCredentials: 'Email and password are required',
    notFound: 'Item not found',
    default: 'An error occurred, please try again',
    tooManyRequests: 'Too many requests. Please try again later 🥺',
    userExists: 'This email is already registered!',
    passwordLength: 'Password must be at least 8 characters',
    invalidCredentials: 'Invalid email or password',
    authServiceUnavailable: 'The authentication service has a backend error. The site owner must check the NoCodeBackend database permissions and authentication configuration.',
    createRecordFailed: 'Unable to save to server, please try again later. 🥺',
  },
  demo: {
    concert: { title: 'My Awesome Concert 🎵', note: 'Remember the glow sticks!' },
    birthday: { title: 'Bestie\'s Birthday', note: 'Secretly ordered strawberry cake 🍓' },
    trip: { title: 'Disneyland Trip', note: 'Gonna ride everything!' },
    project: { title: 'Big Project Launch 💻', note: 'The end of overtime is near!' },
    anniversary: { title: 'Anniversary', note: 'Prepared a surprise gift 🎁' },
    cat: { title: 'We Got a Cat!', note: 'The master has arrived 👑' },
    graduation: { title: 'Graduation Day 🎓', note: 'Unforgettable moments!' },
    firstTrip: { title: 'First Trip Abroad ✈️', note: 'The start of world exploration' },
    braces: { title: 'Braces Off 🦷', note: 'Finally can eat curry again!' },
    newHouse: { title: 'Moved to New House 🏠', note: 'Building our cozy little nest.' },
    firstJob: { title: 'First Day at Work 💼', note: 'The beginning of corporate life!' },
    firstDate: { title: 'First Date ☕', note: 'We were both so nervous.' },
    eighteen: { title: '18th Birthday 👑', note: 'Got my driver license!' }
  }
};